import { createAction, props } from '@ngrx/store';
import { LiveLessonId } from '@pcp/core/interfaces';
import { LiveLesson } from "../interfaces/live-lesson";
import { ActiveLessonInfo } from "./classroomState";

export const startLiveLesson = createAction(
    '[Live Lesson] startLiveLesson',
    props<{ liveLessonId: LiveLessonId }>()
);

export const startLiveLessonFailed = createAction(
    '[Live Lesson] startLiveLesson failed',
    props<{ error: Error }>()
);

/**
 * Live-Lesson started, SignalR connection established and beamer code retrieved.
 */
export const startLiveLessonSuccess = createAction(
    '[Live Lesson] requestLessonCodeSuccess',
    props<{ lesson: ActiveLessonInfo, lessonCode: string, liveLessonId: LiveLessonId }>()
);


/**
 * Fetch a list of all available LiveLessons.
 */
export const fetchLiveLessonList = createAction(
    '[Live Lesson] fetchLiveLessonList'
);

export const fetchLiveLessonListFailed = createAction(
    '[Live Lesson] fetchLiveLessonList failed',
    props<{ error: Error }>()
);

export const fetchLiveLessonListSuccess = createAction(
    '[Live Lesson] fetchLiveLessonList success',
    props<{ liveLessons: LiveLesson[] }>()
);

export const registerLiveLesson = createAction(
    '[Live Lesson] registerLiveLesson'
);

export const registerLiveLessonFailed = createAction(
    '[Live Lesson] registerLiveLesson failed',
    props<{ error: Error }>()
);

export const registerLiveLessonSuccess = createAction(
    '[Live Lesson] registerLiveLesson success',
    props<{ liveLessonId: LiveLessonId }>() // TODO: check response type
);
